import { ReducersMapObject } from 'redux';

import { BaseApplicationState, BaseAppThunkAction, baseReducers } from '@common/react/store';
import * as Item from '@common/react/store/Item';
import * as Items from '@common/react/store/ItemsProviderStore';
import { PageItemState, reducer as PageStateReducer } from '@common/react/store/PageItem';

import { ContentCategory } from '@app/objects/ContentCategory';
import { Issues } from '@app/objects/Questions';
import { ResourceTopic } from '@app/objects/ResourceTopic';
import { User } from '@app/objects/User';

// The top-level state object
export interface ApplicationState extends BaseApplicationState<User> {
	serverPage: PageItemState<any>;
	petHospiceJournalLink: Item.ItemState<string>;
	resourceTopics: Items.ItemsState<ResourceTopic>;
	blogTopics: Items.ItemsState<ContentCategory>;
	faqCategories: Items.ItemsState<Issues>;
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers: ReducersMapObject = {
	...baseReducers,

	serverPage: PageStateReducer<any>('serverPage'),
	petHospiceJournalLink: Item.getReducer<string>('petHospiceJournalLink'),
	resourceTopics: Items.getReducer<ResourceTopic>('resourceTopics'),
	blogTopics: Items.getReducer<ContentCategory>('blogTopics'),
	faqCategories: Items.getReducer<Issues>('faqCategories'),
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export type AppThunkAction<TAction> = BaseAppThunkAction<TAction, User, ApplicationState>;
